import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Menu from '../components/menu';
import Footer from '../components/footer';

export default function References() {
    const [references, setReferences] = useState([]);
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Pobieramy wszystkie referencje z bazy
                const resRefs = await axios.get('https://megamont.pl/api/references');
                setReferences(resRefs.data);

                // Pobieramy wszystkich partnerów z bazy
                const resPartners = await axios.get('https://megamont.pl/api/partners');
                setPartners(resPartners.data);

                setLoading(false);
            } catch (error) {
                console.error("Błąd podczas pobierania danych:", error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return null;

    return (
        <main className='MainPage'>
            <Menu active={4} />
            <section className="References">
                <div className="content">
                    <h1>Referencje</h1>
                    <p className='shortText'>
                        Zadowolenie naszych klientów to nasz największy sukces. 
                        Sprawdź, co mówią o nas firmy, które zaufały naszemu doświadczeniu i profesjonalizmowi.
                    </p>
                    
                    <div className="container" style={{ position: 'relative' }}>
                        <div className="row">
                            {references.map((ref) => (
                                <div className="col-xl-3 col-md-6 mb-4" key={ref.id}>
                                    <img 
                                        className='img' 
                                        src={`https://megamont.pl/uploads/references/${ref.name}`} 
                                        alt="Referencja" 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="Partners">
                        <div className="container">
                            <div className="row">
                                <h1>Nasi Partnerzy</h1>
                                {partners.map((partner) => (
                                    <div className="col-xl-2 col-4 mb-4" key={partner.id}>
                                        <img 
                                            src={`https://megamont.pl/uploads/partners/${partner.name}`} 
                                            alt="Partner" 
                                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    );
}